// assets/dl-bridge.js
(function () {
  // dataLayer global para GTM
  window.dataLayer = window.dataLayer || [];

  // Debe coincidir con el Custom Pixel
  const BRIDGE_SOURCE = 'shopify-pixel-bridge';

  // Lista blanca de eventos que esperamos
  const ALLOWED_EVENTS = new Set([
    'page_viewed',
    'view_item',
    'collection_viewed',
    'search_submitted',
    'view_cart',
    'add_to_cart',
    'remove_from_cart',
    'begin_checkout',
    'purchase'
  ]);

  window.addEventListener('message', function (e) {
    const d = e && e.data;
    if (!d || d.source !== BRIDGE_SOURCE) return;
    if (!ALLOWED_EVENTS.has(d.event)) return;

    window.dataLayer.push({
      event: d.event,
      ...(d.payload || {})
    });
  });
})();
